import { Routes, Route } from 'react-router-dom';
import LoginPage from './auth/LoginPage.jsx';
import ProtectedRoute from './auth/ProtectedRoute.jsx';
import Layout from './common/Layout.jsx';
import Dashboard from './common/Dashboard.jsx';
import ClientList from './clients/ClientList.jsx';
import ClientDetail from './clients/ClientDetail.jsx';
import ImportPage from './clients/ImportPage.jsx';
import MapView from './map/MapView.jsx';
import PlanList from './plans/PlanList.jsx';
import PlanCreate from './plans/PlanCreate.jsx';
import PlanSuggest from './plans/PlanSuggest.jsx';
import PlanDetail from './plans/PlanDetail.jsx';
import DeliveryFlow from './delivery/DeliveryFlow.jsx';
import StatsPage from './stats/StatsPage.jsx';
import ChatView from './notifications/ChatView.jsx';
import SmsLog from './notifications/SmsLog.jsx';
import FieldVisibilityConfig from './admin/FieldVisibilityConfig.jsx';
import UsersPage from './admin/UsersPage.jsx';
import InvitePage from './auth/InvitePage.jsx';
import AppointmentList from './appointments/AppointmentList.jsx';
import ScanHistory from './delivery/ScanHistory.jsx';
import TrackingPage from './tracking/TrackingPage.jsx';
import HelpPage from './common/HelpPage.jsx';
import ProfilePage from './common/ProfilePage.jsx';
import UpdateBanner from './offline/UpdateBanner.jsx';
import CeeDossiersPage from './cee/CeeDossiersPage.jsx';
import CeeDossierDetailPage from './cee/CeeDossierDetailPage.jsx';
import CeeInboxPage from './cee/CeeInboxPage.jsx';
import CeeParametresPage from './cee/CeeParametresPage.jsx';

function NotFound() {
  return (
    <div className="text-center py-16">
      <p className="text-6xl mb-4">🚲</p>
      <h2 className="text-xl font-bold text-[#0f172a] mb-2">Page introuvable</h2>
      <p className="text-[#64748b] mb-6">Cette page n'existe pas.</p>
      <a href="/" className="bg-[#1e40af] text-white px-6 py-3 rounded-xl font-medium">Retour à l'accueil</a>
    </div>
  );
}

export default function App() {
  return (
    <>
      <UpdateBanner />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/invite/:token" element={<InvitePage />} />
        <Route path="/track/:token" element={<TrackingPage />} />
        <Route
          path="/delivery/:planId"
          element={
            <ProtectedRoute>
              <DeliveryFlow />
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="clients" element={<ClientList />} />
          <Route path="clients/:clientId" element={<ClientDetail />} />
          <Route path="import" element={<ImportPage />} />
          <Route path="map" element={<MapView />} />
          <Route path="plans" element={<PlanList />} />
          <Route path="plans/new" element={<PlanCreate />} />
          <Route path="plans/suggest" element={<PlanSuggest />} />
          <Route path="plans/:planId" element={<PlanDetail />} />
          <Route path="stats" element={<StatsPage />} />
          <Route path="chat" element={<ChatView />} />
          <Route path="sms" element={<SmsLog />} />
          <Route path="admin/visibility" element={<FieldVisibilityConfig />} />
          <Route path="admin/users" element={<UsersPage />} />
          <Route path="scan-history" element={<ScanHistory />} />
          <Route path="appointments" element={<AppointmentList />} />
          <Route path="cee/dossiers" element={<CeeDossiersPage />} />
          <Route path="cee/dossiers/:id" element={<CeeDossierDetailPage />} />
          <Route path="cee/inbox" element={<CeeInboxPage />} />
          <Route path="cee/parametres" element={<CeeParametresPage />} />
          <Route path="help" element={<HelpPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}
